import { useCallback, useEffect, useRef } from 'react';

const POINTER_EVENTS = ['mousedown', 'pointerdown', 'dblclick', 'contextmenu', 'wheel', 'mousewheel', 'DOMMouseScroll'];

/**
 * Ferma i gesti prima che arrivino a Leaflet.
 * Il listener è nativo sull'elemento: in React 17 lo stopPropagation di onMouseDown
 * arriva troppo tardi e la mappa interpreta il click (specie col trackpad) come drag.
 * Non si ferma il click, così i bottoni React continuano a riceverlo.
 * blockTouch va usato solo sul layout desktop: sul telefono le azioni sono su touchstart.
 */
export function useMapGestureShield(blockTouch) {
    const cleanupRef = useRef(null);

    const setNode = useCallback((node) => {
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (!node) {
            return;
        }

        const stop = (event) => {
            event.stopPropagation();
        };
        const events = blockTouch ? POINTER_EVENTS.concat('touchstart') : POINTER_EVENTS.slice();
        events.forEach((eventName) => node.addEventListener(eventName, stop));
        cleanupRef.current = () => {
            events.forEach((eventName) => node.removeEventListener(eventName, stop));
        };
    }, [blockTouch]);

    useEffect(() => {
        return () => {
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = null;
            }
        };
    }, []);

    return setNode;
}
